import "./Card.scss";

interface Props {
  active?: boolean;
  onClick?: any;
  centered?: boolean;
  className?: string
  children: any;
  style?: any;
}

export const Card = ({ active, onClick, centered, className, children, style }: Props) => {
  const getClasses = () => {
    const activeClass = active ? "card-active" : "";
    const centeredClass = centered ? "card-centered" : "";

    return ["card", activeClass, centeredClass, className].join(" ");
  };

  return (
    <div className={getClasses()} onClick={onClick} style={style}>
      {children}
    </div>
  );
};
